import cn from 'classnames'

import { TabModeEnum } from '@components/Tabs/interface'
import { Loading } from '@components/Loading'
import { TabsProps } from './interface'

export function Tabs({
  tabs,
  mode,
  activeTab,
  isLoading,
  onTabChange,
}: TabsProps) {
  return (
    <div>
      <div
        className={cn(
          'flex overflow-y-hidden overflow-x-auto scrollbar-none relative',
          {
            'space-x-[15px]': mode === TabModeEnum.BOX,
          }
        )}
      >
        <div
          className={cn('absolute w-full h-[1px] bottom-[1px] bg-gray-3 z-0', {
            hidden: mode === TabModeEnum.BOX,
          })}
        />
        {tabs.map(row => (
          <div className='relative' key={row.key}>
            <button
              type='button'
              className={cn(
                'flex px-[20px] py-[9px] min-w-fit h-[40px] items-center justify-center cursor-pointer font-light whitespace-nowrap text-[14px]',
                {
                  'rounded-[8px] bg-secondary dark:bg-purple text-white dark:text-white-2 dark:border-purple':
                    row.key === activeTab && mode === TabModeEnum.BOX,
                  'rounded-[8px] bg-gray-4 dark:bg-dark-13 text-secondary-1 dark:text-dark-10 dark:border-dark-13':
                    row.key !== activeTab && mode === TabModeEnum.BOX,
                  'text-secondary dark:text-dark-10 font-bold':
                    row.key === activeTab && mode === TabModeEnum.LINE,
                  'text-secondary-1':
                    row.key !== activeTab && mode === TabModeEnum.LINE,
                }
              )}
              onClick={() => onTabChange(row.key)}
            >
              {row.title}
            </button>
            {mode === TabModeEnum.LINE && (
              <hr
                className={cn(
                  'absolute bottom-0 left-0 w-full h-[3px] bg-secondary dark:bg-dark-10 z-[2] rounded-[3px]',
                  { hidden: row.key !== activeTab }
                )}
              />
            )}
          </div>
        ))}
        {mode === TabModeEnum.LINE && (
          <hr className='text-gray-3 dark:text-purple absolute bottom-[1px] w-full' />
        )}
      </div>
      <div>
        {isLoading ? (
          <Loading className='m-auto mt-[50px]' />
        ) : (
          tabs.find(row => row.key === activeTab)?.component
        )}
      </div>
    </div>
  )
}
